import { render, staticRenderFns } from "./MotorcycleLearningRecordTable.vue?vue&type=template&id=dc57ac44&scoped=true&"
import script from "./MotorcycleLearningRecordTable.vue?vue&type=script&lang=js&"
export * from "./MotorcycleLearningRecordTable.vue?vue&type=script&lang=js&"
import style0 from "./MotorcycleLearningRecordTable.vue?vue&type=style&index=0&id=dc57ac44&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc57ac44",
  null
  
)

export default component.exports